import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.sass'],
    standalone: false
})
export class CallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      if (code) {
        this.authService.handleCallback(code).subscribe({
          next: () => {
            this.userService.getUser().subscribe({
              next: () => {
                const redirect = this.authService.getRedirectAfterLogin();
                if (redirect) {
                  this.authService.resetRedirectAfterLogin();
                  this.router.navigateByUrl(redirect);
                } else {
                  this.router.navigate(['/condominiums']);
                }
              },
              error: (error) => {
                console.error('Error fetching user data:', error);
                this.router.navigate(['/']);
              }
            });
          },
          error: (error) => {
            console.error('Error handling callback:', error);
            this.router.navigate(['/']);
          }
        });
      } else {
        this.router.navigate(['/']);
      }
    });
  }
}
